/**
 * Module de galerie de produits avec animation d'opacité (sans scroll)
 */

export function initProductGallery() {
    const gallery = document.querySelector('[data-product-gallery]');
    if (!gallery) return;
    
    const mainImage = gallery.querySelector('[data-main-image]');
    const thumbnailBtns = gallery.querySelectorAll('[data-thumbnail-btn]');
    
    // Elements lightbox
    const lightboxTrigger = gallery.querySelector('[data-lightbox-trigger]');
    const lightboxOverlay = document.querySelector('[data-lightbox-overlay]');
    const lightboxImage = document.querySelector('[data-lightbox-image]');
    const lightboxClose = document.querySelector('[data-lightbox-close]');
    
    if (!mainImage) return;
    
    // Forcer les styles de l'image principale
    function enforceImageStyles(img) {
        img.style.position = 'absolute';
        img.style.top = '0';
        img.style.left = '0';
        img.style.width = '100%';
        img.style.height = '100%';
        img.style.objectFit = 'cover';
        img.style.objectPosition = 'center';
    }
    
    // Appliquer les styles au chargement
    enforceImageStyles(mainImage);
    
    // S'assurer que les styles sont appliqués quand l'image se charge
    mainImage.addEventListener('load', () => enforceImageStyles(mainImage));
    
    // Fonctions lightbox
    function openLightbox() {
        if (lightboxOverlay && lightboxImage && mainImage) {
            // Utiliser data-lightbox-src si disponible, sinon utiliser src
            const lightboxSrc = mainImage.getAttribute('data-lightbox-src') || mainImage.src;
            
            lightboxImage.src = lightboxSrc;
            lightboxImage.alt = mainImage.alt;
            
            // Afficher la lightbox
            lightboxOverlay.style.visibility = 'visible';
            lightboxOverlay.style.opacity = '1';
            
            // Animation de l'image (fade in uniquement)
            setTimeout(() => {
                const img = lightboxOverlay.querySelector('[data-lightbox-image]');
                if (img) {
                    img.style.opacity = '1';
                }
            }, 50);
            
            // Empêcher le scroll du body
            document.body.style.overflow = 'hidden';
        }
    }
    
    function closeLightbox() {
        if (lightboxOverlay) {
            const img = lightboxOverlay.querySelector('[data-lightbox-image]');
            if (img) {
                img.style.opacity = '0';
            }
            
            setTimeout(() => {
                lightboxOverlay.style.opacity = '0';
                lightboxOverlay.style.visibility = 'hidden';
                // Rétablir le scroll du body
                document.body.style.overflow = '';
            }, 150);
        }
    }
    
    // Event listeners lightbox
    if (lightboxTrigger) {
        lightboxTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            openLightbox();
        });
    }
    
    if (lightboxClose) {
        lightboxClose.addEventListener('click', closeLightbox);
    }
    
    if (lightboxOverlay) {
        // Fermer en cliquant sur l'overlay
        lightboxOverlay.addEventListener('click', (e) => {
            if (e.target === lightboxOverlay) {
                closeLightbox();
            }
        });
        
        // Fermer avec la touche Escape
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && lightboxOverlay.style.visibility === 'visible') {
                closeLightbox();
            }
        });
    }
    
    thumbnailBtns.forEach((btn) => {
        btn.addEventListener('click', function() {
            const newImageSrc = this.dataset.image;
            
            // Ne pas changer si c'est déjà l'image active
            if (this.dataset.active === 'true') return;
            
            // Animation d'opacité sur l'image principale
            mainImage.style.transition = 'opacity 0.3s ease-in-out';
            mainImage.style.opacity = '0';
            
            setTimeout(() => {
                mainImage.src = newImageSrc;
                // Mettre à jour l'attribut data-lightbox-src pour la lightbox
                mainImage.setAttribute('data-lightbox-src', newImageSrc);
                mainImage.style.opacity = '1';
                // Réappliquer les styles après changement d'image
                enforceImageStyles(mainImage);
            }, 150);
            
            // Mettre à jour l'état actif des miniatures
            thumbnailBtns.forEach(thumb => {
                thumb.classList.remove('border-orange-500', 'opacity-100');
                thumb.classList.add('border-transparent', 'opacity-60');
                thumb.dataset.active = 'false';
            });
            
            // Activer la miniature cliquée
            this.classList.remove('border-transparent', 'opacity-60');
            this.classList.add('border-orange-500', 'opacity-100');
            this.dataset.active = 'true';
        });
        
        // Effet hover plus subtil
        btn.addEventListener('mouseenter', function() {
            if (this.dataset.active !== 'true') {
                this.classList.remove('opacity-60');
                this.classList.add('opacity-80');
            }
        });
        
        btn.addEventListener('mouseleave', function() {
            if (this.dataset.active !== 'true') {
                this.classList.remove('opacity-80');
                this.classList.add('opacity-60');
            }
        });
    });
}
